<template>
    <div>
        <el-card style="margin-top: 20px;">
            <h5>Election Progress</h5>
           
            <div class="row">
                <div v-for="item,i in collection" :key="i" style="margin-bottom: 20px;" class="col-md-4">
                <div class="bold" style="margin-bottom: 20px;"> 
                    <a class="link" :href="'/barangays/'+item.id+'/analytics'">{{ item.name.toUpperCase() }} <i class="fa fa-hand-pointer-o" aria-hidden="true"></i>
                    </a>    
                </div>

                <div style="margin-bottom: 20px">
                    <div class="text-primary" style="margin-bottom: 10px">{{ item.validated }} validated  voters out of {{ item.total_voters }} total.</div>
                    <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(item,item.validated)" :color="getStatusLabel(item, item.validated)"></el-progress>
                </div>

                <div style="margin-bottom: 20px">
                  <div class="text-info" style="margin-bottom: 10px">{{ item.voted }} votes cast out of {{ item.total_voters }} total voters.</div>
                  <el-progress :text-inside="true" :stroke-width="26" :percentage="getPercentage(item, item.voted)" :color="getStatusLabel(item, item.voted)"></el-progress>
                </div>

                <div style="margin-bottom: 20px">
                  <div class="text-danger" style="margin-bottom: 10px">{{ item.voted_straight }} voted straight out of {{ item.total_voters }} total voters.</div>
                  <el-progress :text-inside="true" :stroke-width="26" :percentage="getPercentage(item, item.voted_straight)" :color="getStatusLabel(item, item.voted_straight)"></el-progress>
                </div>
                <hr>
            </div>
            </div>
        </el-card>
    </div>
  </template>
  
  <script>



  export default {
    props: ['collection'],
  
    data() {
      return {
        show: false,
       
      }
    },
    watch: {
        collection: function(){
        }
    },
    created: function () {
    },
    methods: {
    
    }
  }
  </script>
  
  <style></style>
  